import Vue from 'vue'
import App from './App'
import router from './router'
import '@packages/hello.less'
import './style/global.css'
import QRCodeConsole from '@/components/qrcode'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  created: function () {
    // eslint-disable-next-line
    if (process.env.NODE_ENV === 'development') {
      QRCodeConsole.log(window.location.href);
    }
  },
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js